import { PExt } from 'components/myTags/myTags'
import { Colors } from 'styles/colors'
import './modal.scss'
type props = {
   isOpen: boolean
   onClose?: () => void
   children: any
}
const closeBtn = {
   width: 180,
   height: 60,
   fontSize: 20,
   padding: '15px 50px',
   backgroundColor: Colors.gris1,
   borderRadius: 12,
   border: '1px solid white',
}
const Modal = ({ isOpen, onClose, children }: props) => {
   if (!isOpen) return null

   return (
      <div className='modal-overlay'>
         <div id='modal-background' onClick={() => onClose && onClose()}></div>
         <div className='modal-content'>{children}</div>
         <div id='closeSection'>
            {onClose && (
               <div id='close' style={closeBtn} onClick={() => onClose()}>
                  <PExt fontSize='20px' color='white'>
                     Fermer
                  </PExt>
               </div>
            )}
         </div>
      </div>
   )
}

export default Modal
